module.exports = __webpack_public_path__ + "static/img/create3.264b9351.png";